import { useEffect, useRef, useState } from "react";
import TopBar from "./TopBar";
import Navbar from "./Navbar";
import Breadcrumb from "./Breadcrumb";
import { getOptimizedUrl } from "../lib/imageOptimizer";

function PageBanner({ breadcrumb, title, subtitle, image, children }) {
  const [showStickyNav, setShowStickyNav] = useState(false);
  const sentinelRef = useRef(null);
  const src = image || "/hero-bg.png";
  const overlay = "linear-gradient(180deg, rgba(20,15,10,0.55) 0%, rgba(20,15,10,0.65) 100%)";

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => setShowStickyNav(!entry.isIntersecting));
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="relative">
      <div
        className={
          "fixed top-0 sm:top-4 inset-x-0 z-50 bg-transparent transition-transform duration-300 " +
          (showStickyNav ? "translate-y-0" : "-translate-y-[calc(100%+1rem)]")
        }
      >
        <Navbar />
      </div>

      <div
        className="relative bg-cover bg-center bg-[image:var(--banner-bg-mobile)] sm:bg-[image:var(--banner-bg-desktop)]"
        style={{
          "--banner-bg-mobile": `${overlay}, url('${getOptimizedUrl(src, 800)}')`,
          "--banner-bg-desktop": `${overlay}, url('${getOptimizedUrl(src, 1920)}')`,
        }}
      >
        <header className="relative z-40">
          <TopBar />
          <Navbar />
        </header>
        <div ref={sentinelRef} />

        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12 sm:py-16 text-left sm:text-center text-white">
          <Breadcrumb>{breadcrumb}</Breadcrumb>
          <h1 className="mt-3 text-4xl sm:text-5xl font-semibold">{title}</h1>
          {subtitle && <p className="mt-3 text-gray-200">{subtitle}</p>}
          {children && <div className="mt-6 flex items-center justify-start sm:justify-center gap-3">{children}</div>}
        </div>
      </div>
    </div>
  );
}

export default PageBanner;
